module.exports = __webpack_public_path__ + "img/asus-zenfone-live.7222feda.png";